var rich_content_viewer_default = {
  "fontElementMap": "_8ZVrQ",
  "wrapper": "C7Gda",
  "pluginContainerMobile": "yVMj0",
  "viewer": "tETUs",
  "android": "IReix",
  "rootedTraversedContent": "xentE",
  "atomic": "jhPrZ",
  "toolbar": "_3FSuR",
  "block": "GbUAg"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
